export enum StepState {
  INITIAL,
  READY,
  ACTIVE,
  COMPLETED
}
